module.exports = __webpack_public_path__ + "img/SL-M-100-170.412c0481.svg";